import React, { useEffect, useState, useCallback } from "react";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import SearchIcon from "@mui/icons-material/Search";
import { IconButton } from "@mui/material";
import { useNavigate } from "react-router-dom";
import apiClient from "../../../GlobalUtilities/BaseUrl/apiClient.js";
import "../../../GlobalUtilities/css/App.css";
import "../../../GlobalUtilities/css/color.css";
import _ from "lodash";
import { DISPLAY_PAGE_SIZE } from "../../../GlobalUtilities/constants/Constants.js";
import TokenService from "../../../GlobalUtilities/service/TokenService.js";
import CircularProgress from "@mui/material/CircularProgress";
import ExportToExcelCustomButton from "../../../GlobalComponents/ExportToExcelButtonCustom.js";
import ListDynamicTable from "../../../GlobalComponents/CustomComponant/ListDynamicTable.js";
import SearchTextField from "../../../GlobalComponents/CustomComponant/SearchTextField.js";

function DataReport({ router, setReportId }) {
  const [pageLoader, setPageLoader] = useState(false);
  const [returnData, setReturnData] = useState([]);
  const [reportData, setReportData] = useState([]);
  const [totalRows, setTotalRows] = useState(0);
 const [searchType, setSearchType] = useState("station");
const [searchText, setSearchText] = useState("");
  const navigate = useNavigate();
  const [currentPage, setCurrentPage] = useState(1);
  const pageSize = DISPLAY_PAGE_SIZE;
  const uname = TokenService.getUserDetails()?.uname;

  const handleRowClick = (row) => {
    viewData(row.id);
  };

  const fetchData = useCallback(
    _.debounce(async () => {
      try {
        const dataList = "/reports/alllist.php";
        const response = await apiClient.post(dataList);
        setReportData(response.data);
        setReturnData(response.data);
        setTotalRows(response.data[0]?.totaldata || response.data.length);
      } catch (error) {
        setReportData([]);
        setReturnData([]);
        setTotalRows(0);
      } finally {
        setPageLoader(false);
      }
    }, 300),
    [uname]
  );

  useEffect(() => {
    setPageLoader(true);
    fetchData();
  }, [fetchData]);

  useEffect(() => {
  const delayFilter = setTimeout(() => {
    let filtered = [...reportData];

    if (searchText.trim() !== "") {
      const lowerSearch = searchText.toLowerCase();

      filtered = filtered.filter((item) => {
        const value = item[searchType]?.toLowerCase();
        return value?.includes(lowerSearch);
      });
    }

    setReturnData(filtered);
    setTotalRows(filtered.length);
  }, 300);

  return () => clearTimeout(delayFilter);
}, [searchText, searchType, reportData]);

  const viewData = (reportId) => {
    setReportId(reportId);
    router.navigate(`/details`);
  };

  const columns = [
    "username",
    "ip",
    "lat",
    "lon",
    "filename",
    "entryTime",
    "gang",
    "station",
    "trainno",
    "coachno",
    "cleaningtype",
    "cleanarea",
  ];

  const columnNames = [
    "User Name",
    "IP",
    "Latitude",
    "Longitude",
    "File Name",
    "Entry Date",
    "Gang",
    "Station",
    "Train Number",
    "Coach Number",
    "Cleaning Type",
    "Clean Area",
  ];

  return (
    <div>
      {currentPage === 1 && (
       <div className="d-flex gap-3 mb-3">
  <div className="form-group">
    <label htmlFor="searchType" className="form-label">Search By</label>
    <select
      id="searchType"
      className="form-select"
      value={searchType}
      onChange={(e) => setSearchType(e.target.value)}
    >
      <option value="station">Station Name</option>
      <option value="trainno">Train Number</option>
      {/* Add more options as needed */}
    </select>
  </div>

  <SearchTextField
    label="Search"
    value={searchText}
    title={`Enter ${searchType}`}
    onChange={(e) => setSearchText(e.target.value)}
    adornment={
      <IconButton title="Search">
        <SearchIcon />
      </IconButton>
    }
  />
</div>
      )}

      {pageLoader ? (
        <div className="loaderContainer">
          <CircularProgress />
        </div>
      ) : (
        <ListDynamicTable
          columns={columns}
          columnNames={columnNames}
          data={returnData}
          totalRows={totalRows}
          pageSize={pageSize}
          currentPage={currentPage}
          setCurrentPage={setCurrentPage}
          onRowClick={handleRowClick}
          colorConditionColumn="IndentInPO"
          colorConditionValue="Yes"
        />
      )}

      <div className="container mt-4"></div>

      <div className="container mb-3 mt-2 col-12 gap-4 d-flex justify-content-center">
        <ExportToExcelCustomButton
          data={reportData}
          fileName={"POList"}
          columns={columns}
          columnNames={columnNames}
          buttonTitle="Export to Excel"
        />
      </div>
    </div>
  );
}

export default DataReport;
